import { get } from 'lodash'

interface Centre {
  sys: {
    id: string
  }
}

interface Store {
  centre?: Centre
}

interface Entry {
  stores?: Store[]
  storesCollection?: {
    items?: Store[]
  }
}

export default function getCentreStores(
  centre: Centre,
  entry: Entry
): Store[] | null {
  const centreId = get(centre, 'sys.id')
  if (!centreId) {
    return null
  }
  const store = (
    entry.stores || get(entry, 'storesCollection.items', [])
  ).filter((storeData: Store) => get(storeData, 'centre.sys.id') === centreId)
  return store
}
